import {CABINETS_ONLY} from "../../kvComponent/core/constants";

const checkIfNotShowFeature = (group, cabinetObject, activeFeature) => {

  const showPSA = cabinetObject.partIds.length > 1;

  if (activeFeature.dbFeature.sharedFeatureName === `4 x ${group} PSA Group E`) {
    if (!showPSA) {
      return true
    }
  } else if (activeFeature.dbFeature.sharedFeatureName === `4 x ${group} PSA Top Cabinet`) {
    if (showPSA || !cabinetObject.partIds.includes("top_cabinet")) {
      return true
    }
  } else if (activeFeature.dbFeature.sharedFeatureName === `4 x ${group} PSA Bottom Cabinet`) {
    if (showPSA || !cabinetObject.partIds.includes("bottom_cabinet")) {
      return true
    }
  } else if (activeFeature.dbFeature.sharedFeatureName === `4 x ${group} PSA Center Island Cabinet`) {
    if (showPSA || !cabinetObject.partIds.includes("center_island_cabinet")) {
      return true
    }
  }
  return false
}

const getPSAQuantityForCabinets = (cabinetObject, activeFeature) => {
  switch (activeFeature.dbFeature.sharedFeatureName) {
    case "4 x 8 PSA Group E":
    case "4 x 8 PSA Top Cabinet":
    case "4 x 8 PSA Bottom Cabinet":
    case "4 x 8 PSA Center Island Cabinet": {
      if (checkIfNotShowFeature("8", cabinetObject, activeFeature)) {
        return 0
      }
      if (cabinetObject.quantity <= 40) {
        return 1
      } else if (cabinetObject.quantity <= 100) {
        return 0
      } else if (cabinetObject.quantity <= 130) {
        return 2
      } else if (cabinetObject.quantity <= 190) {
        return 1
      } else if (cabinetObject.quantity <= 280) {
        return 0
      } else if (cabinetObject.quantity <= 310) {
        return 1
      } else {
        return 0
      }
    }
    case "4 x 10 PSA Group E":
    case "4 x 10 PSA Top Cabinet":
    case "4 x 10 PSA Bottom Cabinet":
    case "4 x 10 PSA Center Island Cabinet": {
      if (checkIfNotShowFeature("10", cabinetObject, activeFeature)) {
        return 0
      }
      if (cabinetObject.quantity <= 40) {
        return 0
      } else if (cabinetObject.quantity <= 70) {
        return 1
      } else if (cabinetObject.quantity <= 130) {
        return 0
      } else if (cabinetObject.quantity <= 160) {
        return 1
      } else if (cabinetObject.quantity <= 190) {
        return 0
      } else if (cabinetObject.quantity <= 220) {
        return 2
      } else if (cabinetObject.quantity <= 250) {
        return 1
      } else {
        return 0
      }
    }
    case "4 x 12 PSA Group E":
    case "4 x 12 PSA Top Cabinet":
    case "4 x 12 PSA Bottom Cabinet":
    case "4 x 12 PSA Center Island Cabinet": {
      if (checkIfNotShowFeature("12", cabinetObject, activeFeature)) {
        return 0
      }
      if (cabinetObject.quantity <= 70) {
        return 0
      } else if (cabinetObject.quantity <= 100) {
        return 1
      } else if (cabinetObject.quantity <= 160) {
        return 0
      } else if (cabinetObject.quantity <= 190) {
        return 1
      } else if (cabinetObject.quantity <= 220) {
        return 0
      } else if (cabinetObject.quantity <= 250) {
        return 1
      } else if (cabinetObject.quantity <= 310) {
        return 2
      } else {
        return 0
      }
    }
    default:
      break;
  }
  return 0
}

/**
 * @param activeFeature {featureInterface}
 * @param cartItems {[cartItemInterface]}
 * @param activeQuoteIndex {number}
 */
export const getPSADefaultQuantity = (activeFeature, cartItems, activeQuoteIndex) => {
  if (!activeFeature || !cartItems || !cartItems.length) {
    return 0
  }
  let allCabinets = []; // {quantity: 0, sharedFeatureName: "", partIds: []}

  cartItems.forEach((cItem) => {
    if (cItem.currentQuote !== activeQuoteIndex) {
      return
    }
    if (CABINETS_ONLY.includes(cItem.partId)) {
      const existingIndex = allCabinets.findIndex(cabObject => {
        return cabObject.sharedFeatureName === cItem.cartFeature.dbFeature.sharedFeatureName
      });
      if (existingIndex > -1) {
        allCabinets[existingIndex].quantity += cItem.quantity;
        if (!allCabinets[existingIndex].partIds.includes(cItem.partId)) {
          allCabinets[existingIndex].partIds.push(cItem.partId);
        }
      } else {
        allCabinets.push({
          quantity: cItem.quantity,
          sharedFeatureName: cItem.cartFeature.dbFeature.sharedFeatureName,
          partIds: [cItem.partId]
        })
      }
    }
  });
  if (!allCabinets.length) {
    return 0
  }

  return allCabinets.reduce((totalQuantity, cabinetObject) => {
    return totalQuantity + getPSAQuantityForCabinets(cabinetObject, activeFeature);
  }, 0)
}
